function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M7 19A7 7 0 1 0 7 5a7 7 0 0 0 0 14z",
  fill: "#EA001B"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14z",
  fill: "#FFA200",
  fillOpacity: 0.8
});

var SvgMasterCard = function SvgMasterCard(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/master-card.89f9b6ee.svg";
export { SvgMasterCard as ReactComponent };